import React from 'react'
import { memoize } from 'lodash'
import {
  ProgressPanel,
  ProPanel,
  ShopPanel,
  UserSuggestionsPanel,
} from '../../features/ui/util/async_components'
import WrappedBundle from '../../features/ui/util/wrapped_bundle'
import { me, showSuggestedUsers } from '../../initial_state'

function RandomSidebarPanels() {
  return [
    <WrappedBundle component={ProPanel} />,
    <WrappedBundle component={ProgressPanel} />,
    <WrappedBundle component={ShopPanel} />,
    (showSuggestedUsers || !me) && <WrappedBundle component={UserSuggestionsPanel} />,
  ].filter(Boolean)
}

export default memoize(RandomSidebarPanels)